import { FormattedMessage } from 'react-intl'
import { shallowEqual, useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router'

import Price from '@components/UI/Price/Price'
import { IApplicationState } from '@store'
import { selectCampaignId } from '@store/router'
import {
  selectEstimatedCPE,
  selectEstimatedCPECurrency,
  selectIsPriceHidden,
  selectSubTotalCents,
} from '@store/submissions'
import Theme from '@theme'
import { Container, H5 } from '@tribegroup'
import { isEmpty } from '@utils'
import SubmissionCardHeaderPrice from './Price/Price'
import SubmissionCardHeaderActions from './Actions'
import { SubmissionCardHeaderRoot, SubmissionCardMainHeader } from './Header.styled'

interface ISubmissionCardHeaderProps {
  submissionId: number
  toggleCostBreakdown?: (event: React.MouseEvent) => void
}

const SubmissionCardHeaderCPE: React.FC<ISubmissionCardHeaderProps> = ({
  submissionId,

  toggleCostBreakdown,
}) => {
  const match = useRouteMatch()
  const { campaignId, currency, estimatedCpe, showPrice, isPriceHidden } = useSelector(
    (state: IApplicationState) => {
      const campaignId = selectCampaignId(match)
      const isPriceHidden = selectIsPriceHidden(state, submissionId)
      const showPrice = !isEmpty(selectSubTotalCents(state, submissionId)) && !isPriceHidden
      return {
        campaignId,
        showPrice: showPrice,
        isPriceHidden,
        estimatedCpe: selectEstimatedCPE(state, submissionId),
        currency: selectEstimatedCPECurrency(state, submissionId),
      }
    },
    shallowEqual,
  )

  if (!campaignId) {
    return null
  }

  return (
    <SubmissionCardHeaderRoot>
      <SubmissionCardMainHeader full justifyBetween alignCenter>
        {estimatedCpe && !isPriceHidden ? (
          <H5 uppercase color={Theme.grey700Color}>
            <FormattedMessage id="submission.performance.estCpe" />
            &nbsp;
            <Price quantity={estimatedCpe} currency={currency} />
          </H5>
        ) : (
          <>&nbsp;</>
        )}
        {showPrice && (
          <SubmissionCardHeaderPrice
            toggleCostBreakdown={toggleCostBreakdown}
            submissionId={submissionId}
            campaignId={campaignId}
          />
        )}
      </SubmissionCardMainHeader>
      <Container height={1.75}>
        <SubmissionCardHeaderActions submissionId={submissionId} campaignId={campaignId} />
      </Container>
    </SubmissionCardHeaderRoot>
  )
}
export { SubmissionCardHeaderCPE }
export default SubmissionCardHeaderCPE
